module.exports = __webpack_public_path__ + "static/media/home2025.de6b819f.png";